<template>
	<div v-if="hint">
		<v-alert
			:color="hint.color || '#4db6ac'"
			:title="hint.label"
			density="compact"
			rounded="lg"
			variant="tonal"
			style="font-size: small"
		>
			<template #title>
				<div class="d-flex align-center justify-space-between" style="width: 100%">
					<v-icon class="ma-1" :icon="`mdi-${hint.icon || 'lightbulb-on'}`"></v-icon>
					<span class="hint-title text-truncate">{{ hint.label }}</span>
					<v-btn variant="text" size="x-small" icon="mdi-close" @click="onHintClose" />
				</div>
			</template>
			<template #text>
				{{ hint.description }}
			</template>
		</v-alert>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useGraphStore } from "../../../store/graph";

const graphStore = useGraphStore();

const hint = computed(() => graphStore.descriptor.notifications.find((n) => n.display === "hint"));

function onHintClose() {
	if (!hint.value) return;
	graphStore.descriptor.notification.remove(hint.value.id);
}
</script>

<style scoped lang="scss">
.hint-title {
	flex: 1;
	min-width: 0;
}
</style>
